export default __webpack_public_path__ + "static/media/CapaUserFollow.f6d541a0.svg";